const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulkCreate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M480.7 11H130.4c-11.3 0-20.4 9.1-20.4 20.4v60.3H31.5c-11.3 0-20.4 9.1-20.4 20.4v368.5c0 11.3 9.1 20.4 20.4 20.4h350.3c11.3 0 20.4-9.1 20.4-20.4v-60.3h78.5c11.3 0 20.4-9.1 20.4-20.4V31.4c0-11.3-9.2-20.4-20.4-20.4ZM361.3 460.2H51.9V132.5h309.4v327.7Zm98.9-80.7h-58.1V112.1c0-11.3-9.1-20.4-20.4-20.4h-231V51.8h309.4v327.7h.1Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(-.04082 0 0 .04082 29.364 8.484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8 242.6h157.7c11.3 0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4H127.8c-11.3 0-20.4 9.1-20.4 20.4 0 11.3 9.1 20.4 20.4 20.4Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(0 .04082 .04082 0 12.024 12.129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8 390.9h157.7c11.3 0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4H127.8c-11.3 0-20.4 9.1-20.4 20.4 0 11.2 9.1 20.4 20.4 20.4Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    },
    transform: "matrix(-.04082 0 0 .04082 29.528 5.44)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480.7 11H130.4c-11.3 0-20.4 9.1-20.4 20.4v60.3H31.5c-11.3 0-20.4 9.1-20.4 20.4v368.5c0 11.3 9.1 20.4 20.4 20.4h350.3c11.3 0 20.4-9.1 20.4-20.4v-60.3h78.5c11.3 0 20.4-9.1 20.4-20.4V31.4c0-11.3-9.2-20.4-20.4-20.4ZM361.3 460.2H51.9V132.5h309.4v327.7Zm98.9-80.7h-58.1V112.1c0-11.3-9.1-20.4-20.4-20.4h-231V51.8h309.4v327.7h.1Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(-.04082 0 0 .04082 69.364 8.484)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8 242.6h157.7c11.3 0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4H127.8c-11.3 0-20.4 9.1-20.4 20.4 0 11.3 9.1 20.4 20.4 20.4Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(0 .04082 .04082 0 52.024 12.129)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8 390.9h157.7c11.3 0 20.4-9.1 20.4-20.4 0-11.3-9.1-20.4-20.4-20.4H127.8c-11.3 0-20.4 9.1-20.4 20.4 0 11.2 9.1 20.4 20.4 20.4Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(-.04082 0 0 .04082 69.528 5.44)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkCreate);
export default __webpack_public_path__ + "static/media/bulk-create.d85ceb14e31c8f81cda2ec061d840ec5.svg";
export { ForwardRef as ReactComponent };